import { getNationalDigits } from "../../../../../utils/helpers";
import { IDR_CALLING_CODE } from "./const";
import { IndonesiaFormInputs } from "./types";

export const buildIndonesiaPayoutPayload = (saved: IndonesiaFormInputs, otp?: string) => {
  const common = {
    quotationId: saved.quotationId,
    purpose: saved.purpose,
    purposeCode: saved.purpose,
    requestId: saved.reference,
    otp,
    currency: "IDR",
  };

  switch (saved.paymentMethod) {
    case "wallet":
      return {
        ...common,
        destinationType: saved.paymentMethod,
        walletType: saved.walletType,
        accountName: saved.accountName,
        accountNumber: saved.accountNumber,
        mobileNumber: (saved.phoneNumber ?? "").replace(/\D/g, ""),
      };
    case "bank":
    case undefined:
      return {
        ...common,
        destinationType: saved.paymentMethod,
        accountName: saved.accountName,
        bankName: saved.bankName,
        swiftCode: saved.swiftCode,
        accountNumber: saved.accountNumber,
        narration: saved.narration,
        phone: {
          calling_code: IDR_CALLING_CODE,
          number: getNationalDigits(saved.phoneNumber ?? "", IDR_CALLING_CODE),
        },
      };
    default: {
      const unhandled: never = saved.paymentMethod;
      return unhandled;
    }
  }
};
